module.exports = __webpack_public_path__ + "web/img/xiaohai.8fd82876.png";